const table = [
    {
        prop: 'Region',
        label: 'Región',
        minWidth: 100
    },
    {
        prop: 'Depart_Code',
        label: 'Cod. Dpto.',
        minWidth: 100
    },
    {
        prop: 'Depart_Nombre',
        label: 'Departamento',
        minWidth: 150
    },
    {
        prop: 'Municipio_Code',
        label: 'Cod. Munic.',
        minWidth: 100
    },
    {
        prop: 'Municipio_Nombre',
        label: 'Municipio',
        minWidth: 150
    },
    {
        prop: 'Direccion',
        label: 'Dirección',
        minWidth: 150
    },
    {
        prop: 'IDPunto',
        label: 'ID Punto',
        minWidth: 150
    },
    {
        prop: 'Coordenadas',
        label: 'Coordenadas',
        minWidth: 150
    },
    {
        prop: 'Estrato',
        label: 'Estrato',
        minWidth: 100
    },
    {
        prop: 'Nombres',
        label: 'Cliente',
        minWidth: 150
    },
    {
        prop: 'Estado',
        label: 'Estado',
        minWidth: 150
    },
    {
        prop: 'FechaGenera',
        label: 'Fecha de Instalación',
        minWidth: 150
    },
/*     {
        prop: 'DiasPendienteMeta',
        label: 'Dias Pendientes',
        minWidth: 150
        className: 150
    } */
]


const table_plus = [
    {
        prop: "Operador",
        label: "Operador", 
    },
    {
        prop: "FechaUpdate",
        label: "Fecha de Actualización", 
    },
    {
        prop: "Barrio",
        label: "Barrio", 
    },
    {
        prop: "Dificultades_Acceso",
        label: "Dificultad Acceso", 
    },
    {
        prop: "Cedula",
        label: "Cedula", 
    },
    {
        prop: "Telefono",
        label: "Telefono", 
    },
    {
        prop: "Celular",
        label: "Celular", 
    },
    {
        prop: "CorreoE",
        label: "Email", 
    },
    {
        prop: "VIP",
        label: "VIP", 
    },
    {
        prop: "ProyectoCodeVIP",
        label: "Código VIP", 
    },
    {
        prop: "ProyectoNombreVIP",
        label: "Nombre VIP", 
    },
    {
        prop: "velBajada",
        label: "vel Bajada", 
    },
    {
        prop: "velSubida",
        label: "vel Subida", 
    },
    {
        prop: "VelocidadContratada",
        label: "Vel Contratada", 
    },
    {
        prop: "Meta",
        label: "Meta", 
    },
    {
        prop: "FecMeta",
        label: "Fecha Meta", 
    },
    {
        prop: "DiasPendienteMeta",
        label: "Dias Pendientes Meta", 
    },
    {
        prop: "FecInterventoria",
        label: "Fecha Interventoria", 
    },
    {
        prop: "FecMetaSupervision",
        label: "Fecha Supervisión", 
    },
    {
        prop: "UltimaMilla",
        label: "Ultima Milla", 
    },
    {
        prop: "OperadorPrestante",
        label: "Operador Prestante", 
    },
    {
        prop: "SolUM",
        label: "SolUM", 
    },
    {
        prop: "IP",
        label: "IP", 
    },
    {
        prop: "OLT",
        label: "OLT", 
    },
    {
        prop: "PuertoOLT",
        label: "Puerto OLT", 
    },
    {
        prop: "MAC",
        label: "MAC", 
    },
    {
        prop: "PortONU",
        label: "PortONU", 
    },
    {
        prop: "Nodo",
        label: "Nodo", 
    },
    {
        prop: "Armario",
        label: "Armario", 
    },
    {
        prop: "RedPrimaria",
        label: "Red Primaria", 
    },
    {
        prop: "RedSecundaria",
        label: "Red Secundaria", 
    },
    {
        prop: "Ndo",
        label: "Ndo", 
    },
    {
        prop: "Amplificador",
        label: "Amplificador", 
    },
    {
        prop: "TapBoca",
        label: "TapBoca", 
    },
    {
        prop: "MacCpe",
        label: "MacCpe", 
    },
    {
        prop: "FecAsignado",
        label: "Fecha Asignado", 
    },
    {
        prop: "FecProcesoInstalacion",
        label: "Fecha Proceso Instalacion", 
    },
    {
        prop: "FecAnulado",
        label: "Fecha Anulado", 
    },
    {
        prop: "FecInstalado",
        label: "Fecha Instalado", 
    },
    {
        prop: "FecActivoInternet",
        label: "Fecha Activado", 
    },
    {
        prop: "fecAprobacionMeta",
        label: "Fecha Aprobación", 
    },
    {
        prop: "AnexContrato",
        label: "Anexo. Contrato", 
    },
    {
        prop: "AnexCC",
        label: "Anexo CC", 
    },
    {
        prop: "AnexDeclarion",
        label: "Anexo Declaración", 
    },
    {
        prop: "AnexSisben",
        label: "Anexo Sisben", 
    },
    {
        prop: "AnexSisbenCertificado",
        label: "Anexo Sisben Cert.", 
    },
    {
        prop: "AnexLey1699",
        label: "Anexo Ley 1699", 
    },
    {
        prop: "AnexSP",
        label: "Anexo SP", 
    },
    {
        prop: "AnexPR",
        label: "Anexo PR", 
    },
    {
        prop: "AnexFactura",
        label: "Anexo Factura", 
    },
    {
        prop: "AnexTestVelocidad",
        label: "Anexo Test de Velocidad", 
    },
    {
        prop: "AnexControlOP",
        label: "Anexo Control OP", 
    },
    {
        prop: "Sisben4",
        label: "Sisben4", 
    },
    {
        prop: "Etnia",
        label: "Etnia", 
    },
    {
        prop: "Genero",
        label: "Género", 
    },
    {
        prop: "OrientSexual",
        label: "Orientación Sexual", 
    },
    {
        prop: "Sexo",
        label: "Sexo", 
    },
    {
        prop: "NivelEducativo",
        label: "Nivel Educativo", 
    },
    {
        prop: "Discapacidad",
        label: "Discapacidad", 
    } 
]

export default [table, table_plus]